import { Box, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RecentlyViewedItem } from 'RecentlyViewed';
import useRecentlyViewed from '../../hooks/admin/useRecentlyViewed';
import { StyledHeading } from '../styles/styles';
import { RecentlyViewedCompactCards } from './RecentlyViewedCompactCards';
import { getRecentlyViewedNavigationPath } from './recentlyViewedSidebarUtils';

const RECENTLY_VIEWED_LIMIT = 5;

export default function ContactRecentlyViewedSection() {
  const { getRecentlyViewed } = useRecentlyViewed();
  const navigate = useNavigate();
  const [items, setItems] = useState<RecentlyViewedItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getRecentlyViewed('CONTACT', RECENTLY_VIEWED_LIMIT, 1)
      .then((response) => {
        if (!cancelled) setItems(response.data);
      })
      .catch((err) => console.warn('Failed to load recently viewed contacts:', err))
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [getRecentlyViewed]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={1}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <Box>
      <StyledHeading tone="tone1" fullTopSpacing sx={{ mb: 1.5 }}>
        Recently Viewed Contacts
      </StyledHeading>
      <RecentlyViewedCompactCards
        items={items}
        tone="tone1"
        onItemClick={(item) => navigate(getRecentlyViewedNavigationPath(item))}
      />
    </Box>
  );
}
